import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import React from "react";
interface GenericSaveButtonProps {
    onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void;
    onCancelClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
    cancelLabel?: string;
    saveLabel?: string;
    backgroundColor?: string;
    textColor?: string;
    minWidth?: string;
    fontWeight?: number | string;
    className?: string;
    disabled?: boolean;
    showSaveButton?: boolean; 
    showCancelButton?: boolean;
}

export function GenericSaveButton({
    onClick,
    onCancelClick,
    cancelLabel,
    saveLabel,
    backgroundColor,
    textColor = "#fff",
    minWidth = "180px", 
    fontWeight = 600,
    className = "",
    disabled = false,
    showSaveButton = true,
    showCancelButton = true
}: GenericSaveButtonProps) {
    
    const { t } = useTranslation(['common']);

    return (
        <>
            {onCancelClick && showCancelButton && (
                <Button
                    variant="secondary"
                    onClick={onCancelClick}
                    style={{ height: "38px" }}
                >
                    {cancelLabel ?? t("common:buttons.buttonCancel")}
                </Button>
            )}
            {showSaveButton && (
                <Button 
                    variant={backgroundColor ? undefined : "primary"} 
                    className={`ms-2 ${className}`} 
                    onClick={onClick}
                    disabled={disabled}
                    style={{
                        backgroundColor: backgroundColor,
                        borderColor: backgroundColor, 
                        color: textColor,
                        minWidth: minWidth,
                        fontWeight: fontWeight,
                        height: "38px"
                    }}
                >
                    {saveLabel ?? t("common:buttons.buttonSave")}
                </Button>
            )}
        </>
    );
}
